import { createContext } from "react";

export interface SidebarContextType {
    collapsed: boolean;
    setCollapsed: (v: boolean) => void;
}

// non-null default (no-op) so callers don't need `?.` like ProjectContext does
export const SidebarContext = createContext<SidebarContextType>({
    collapsed: false,
    setCollapsed: () => {},
});
